module.exports = __webpack_public_path__ + "img/types-of-experiments.6a8408b1.png";